<template>
  <header>
    <div class="container-fluid">
      <div class="row">
        <div class="area">
          <div class="logo-box">
            <h1>
              <a href="javascript:">
                <span class="logo"></span>
              </a>
            </h1>
          </div>
          <div class="tab-box">
            <div
              class="tab"
              :class="{ on: location === 'Home' }"
              @click="setPage('/')"
            >
              <h2 v-text="$t('home')"></h2>
            </div>
            <div
              class="tab"
              :class="{ on: location === 'Video' }"
              @click="setPage('/video')"
            >
              <h2 v-text="$t('movie_send.title')"></h2>
            </div>
          </div>
          <div class="profile-box">
            <div class="name">
              {{ $t('greeting') }}
              <span v-text="userName + $t('nim')"></span>
            </div>
            <div class="image">
              <a
                href="javascript:"
                @click="isProfilePopupOpened = !isProfilePopupOpened"
              >
                <lazy-image-component
                  :imageURL="profilePhoto"
                  imageTitle="User Image"
                  imageWidth="100%"
                  imageHeight="100%"
                  loadingTop="-45%"
                  loadingLeft="-45%"
                ></lazy-image-component>
              </a>
            </div>
            <div
              class="menu"
              @click="isProfilePopupOpened = !isProfilePopupOpened"
            >
              <img
                src="@assets/images/icon-arrow-down-on.png"
                alt="Icon Arrow Down"
              />
              <div v-if="isProfilePopupOpened" class="popup-profile">
                <div class="profile">
                  <div class="user-image">
                    <img :src="profilePhoto" alt="user Image" />
                  </div>
                  <h3 v-text="userName"></h3>
                </div>
                <ul>
                  <li
                    @click="toMyPage"
                    v-text="$t('profile.personal_setting')"
                  ></li>
                  <li @click="goLogout" v-text="$t('logout')"></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import api from '@api/index';
import lazyImageComponent from '@components/LazyImage.vue';

export default {
  name: 'Header',
  components: {
    lazyImageComponent,
  },
  computed: {
    ...mapGetters([
      'getSelectedDevice',
      'fetchedUserProfile',
      'fetchedUserProfileImage',
    ]),
  },
  data() {
    return {
      location: 'Home',
      isProfilePopupOpened: false,
      userName: '',
      profilePhoto: '',
      isProfileImgChk: false,
    };
  },
  async created() {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info'));
    const profilePhoto = await import('@assets/images/image-profile.png');
    this.location = this.$route.name;
    this.userName = userInfo.user.user_name;
    this.profilePhoto = profilePhoto.default;

    if (_.isEmpty(this.fetchedUserProfile)) {
      await this.$store.dispatch('FETCH_USER_PROFILE', userInfo.user.user_id);
    }

    this.userName = this.fetchedUserProfile.user_name;

    if (this.fetchedUserProfile.profile_pic_exist === 'Y') {
      if (!this.fetchedUserProfileImage) {
        await this.FETCH_USER_PROFILE_IMAGE();
      }

      this.profilePhoto = this.fetchedUserProfileImage;
    }
  },
  methods: {
    ...mapActions(['FETCH_USER_PROFILE_IMAGE']),
    async goLogout() {
      const { data } = await api.auth.logout();

      if (data.code === Common.CODE_OK) {
        sessionStorage.clear();
        window.location.href = `${window.location.origin}/auth/login`;
      }
    },
    setPage(page) {
      const fullPath = _.toLower(this.$route.fullPath);

      if (page === '/' && fullPath !== '/') {
        this.$router.push('/');
      } else if (page === '/video' && fullPath !== '/video') {
        if (!this.getSelectedDevice?.product_type_id) {
          alert(eve.Lang.t('common.t_not_exist_sign'));
          return;
        }

        this.$router.push('/video');
      }
    },
    toMyPage() {
      this.isProfilePopupOpened = false;
      const fullPath = _.toLower(this.$route.fullPath);
      if (fullPath !== '/mypage') this.$router.push('/mypage');
    },
  },
};
</script>

<style scoped lang="scss">
header {
  width: 100%;
  height: 58px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: $white;
  -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  z-index: 10;

  & > div,
  .row {
    height: 100%;
  }

  .area {
    width: 100%;
    height: 100%;
    position: relative;

    .logo-box {
      width: 58px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;

      h1 {
        width: 100%;
        height: 100%;
        padding: 14px;
        text-align: center;
        border-right: 1px solid $gray-f3;

        span.logo {
          background-image: url('~@assets/images/logo-gnb.png');
          background-position: center;
        }
      }
    }

    .tab-box {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .tab {
        height: 100%;
        padding: 10px 0;
        display: flex;
        align-items: center;
        cursor: pointer;

        h2 {
          font-size: 14px;
          color: $gray-a2;
        }

        &.on {
          position: relative;

          &:after {
            content: '';
            position: absolute;
            width: 100%;
            height: 2px;
            bottom: 0;
            background-color: $gray-4c;
          }

          h2 {
            color: $gray-4c;
          }
        }
      }

      .tab + .tab {
        margin-left: 32px;
      }
    }

    .profile-box {
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;

      .name {
        font-size: 14px;
        font-weight: 600;
        color: $gray-4c;

        span {
          font-size: inherit;
          font-weight: 600;
          color: $primary;
        }
      }

      @media (max-width: 640px) {
        .name {
          display: none;
        }
      }

      .image {
        overflow: hidden;
        width: 36px;
        height: 36px;
        margin-left: 16px;
        border-radius: 18px;
        cursor: pointer;
        box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.1);

        a {
          font-size: 0.625rem;
        }

        img {
          width: 100%;
          height: 100%;
          min-width: 100%;
          min-height: 100%;
          object-fit: cover;
        }
      }

      .menu {
        margin: 0 16px;
        cursor: pointer;
        position: relative;

        .popup-profile {
          width: 140px;
          padding: 12px 12px 0 12px;
          position: absolute;
          top: 35px;
          right: -16px;
          background-color: $white;
          border: 1px solid $gray-e3;
          border-radius: 2px;
          -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
          -moz-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
          -ms-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
          z-index: 10;

          &::after {
            content: '';
            width: 12px;
            height: 12px;
            margin: auto;
            position: absolute;
            top: -6px;
            left: 12px;
            right: 0;
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            -o-transform: rotate(45deg);
            transform: rotate(45deg);
            border: solid #d4d4d4;
            border-width: 1px 0 0 1px;
            background-color: $white;
            z-index: 110;
          }

          .profile {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            position: relative;
            width: 100%;
            padding-bottom: 12px;
            border-bottom: 1px solid $gray-e3;

            .user-image {
              width: 36px;
              height: 36px;
              -webkit-border-radius: 18px;
              -moz-border-radius: 18px;
              border-radius: 18px;
              overflow: hidden;
              -webkit-box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.1);
              -moz-box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.1);
              -ms-box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.1);
              box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.1);

              img {
                width: 100%;
                height: 100%;
                min-width: 100%;
                min-height: 100%;
                object-fit: cover;
              }
            }

            h3 {
              margin-left: 10px;
              font-size: 14px;
              font-weight: 600;
              color: $primary;
            }
          }

          ul {
            width: 100%;
            display: block;
            padding: 10px 12px;

            li {
              width: 100%;
              padding: 8px 0;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              color: $gray-66;
              font-size: 12px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
